import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { getNativeContext } from '../helpers/get-native-context';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers'
};
export var createMediaStreamAudioSourceNodeConstructor = function createMediaStreamAudioSourceNodeConstructor(createNativeMediaStreamAudioSourceNode, createNotSupportedError, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(MediaStreamAudioSourceNode, _noneAudioDestination);

      function MediaStreamAudioSourceNode(context, options) {
        var _this;

        _classCallCheck(this, MediaStreamAudioSourceNode);

        var nativeContext = getNativeContext(context);

        if (isNativeOfflineAudioContext(nativeContext)) {
          throw createNotSupportedError();
        }

        var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

        var nativeMediaStreamAudioSourceNode = createNativeMediaStreamAudioSourceNode(nativeContext, mergedOptions);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaStreamAudioSourceNode).call(this, context, 'active', nativeMediaStreamAudioSourceNode, null)); // Bug #63: Edge & Firefox do not expose the mediaStream yet.
        // Bug #151: The mediaStream gets cloned for Firefox but luckily it doesn't expose it at the same time.

        _this._mediaStream = mergedOptions.mediaStream;
        _this._nativeMediaStreamAudioSourceNode = nativeMediaStreamAudioSourceNode;
        return _this;
      }

      _createClass(MediaStreamAudioSourceNode, [{
        key: "mediaStream",
        get: function get() {
          return this._nativeMediaStreamAudioSourceNode.mediaStream === undefined ? this._mediaStream : this._nativeMediaStreamAudioSourceNode.mediaStream;
        }
      }]);

      return MediaStreamAudioSourceNode;
    }(noneAudioDestinationNodeConstructor)
  );
};